<template>
    <div id="alarms">
        <HeaderSidebarRight :id_header="id_header" :title_header="title_header" />
        <div class="alarm-container">
            <div class="form-item form-type-select form-item-selected">
                <div class="info-ticker-box">
                    <p class="text-info-ticker">Ticker: <span class="text-bold">{{ _g_SelectedTicker.ticker }}</span></p>
                </div>
            </div>
        </div>
        <div class="checkbox-container">
          <div class="every-checkbox-container" @click="_getValueFromCheckbox(key_checkbox_cotizacion, 'valor_actual')">
            <CheckBox class="checkbox"
              :label_name="label_name_checkbox_cotizacion" 
              :checkbox_key="key_checkbox_cotizacion" 
              :checkbox_id="id_checkbox_cotizacion" 
              :checkbox_state="true"
              />
          </div>
          <div class="every-checkbox-container" @click="_getValueFromCheckbox(key_checkbox_soporte, 'soport')">
            <CheckBox class="checkbox"
              :label_name="label_name_checkbox_soporte" 
              :checkbox_key="key_checkbox_soporte" 
              :checkbox_id="id_checkbox_soporte" 
              :checkbox_state="false" 
              />   
          </div>

          <div class="every-checkbox-container" @click="_getValueFromCheckbox(key_checkbox_entrada, 'entrada')">
            <CheckBox class="checkbox"
              :label_name="label_name_checkbox_entrada" 
              :checkbox_key="key_checkbox_entrada" 
              :checkbox_id="id_checkbox_entrada" 
              :checkbox_state="false" 
             />
          </div>

          <div class="every-checkbox-container" @click="_getValueFromCheckbox(key_checkbox_stop, 'out_price')">
            <CheckBox class="checkbox"
              :label_name="label_name_checkbox_stop" 
              :checkbox_key="key_checkbox_stop" 
              :checkbox_id="id_checkbox_stop" 
              :checkbox_state="false" 
              />
          </div>

          <div class="every-checkbox-container" @click="_getValueFromCheckbox(key_checkbox_distancia_entrada, 'entry_distance')" style="display: contents">
            <CheckBox class="checkbox"
              :label_name="label_name_checkbox_distancia_entrada" 
              :checkbox_key="key_checkbox_distancia_entrada" 
              :checkbox_id="id_checkbox_distancia_entrada" 
              :checkbox_state="false" 
              />
          </div>
        </div>
        <div style="display:flex;">
          <SelectOutline 
            :key="key_select_operation"
            :ref="ref_select_operation"
            :component_class="component_class_select_operation"
            :label_name="label_name_select_operation"
            :options="options_select_operation"
            :default_value="default_value_select_operation"
            :helper_select_permission="helper_select_permission_select_operation"
            @_emit_method_order_select="_getValueFromOperationSelect"
            class="operaton-select-style"/>

          <InputTextOutline 
            class="value-input" 
            @_emit_method_order_input="_getValueFromInputValue"
            :input_label="value_input_label"  
            :input_helper="value_input_helper" 
            :has_focus="value_has_focus"
            :icon_class="value_icon_class" 
            :input_key_to_save_user_values="value_input_key_to_save_user_values" 
            :input_class_character_counter="value_input_class_character_counter" 
            :permission="value_permission" 
            :icon_permission="value_icon_permission" 
            :character_counter_permission="value_character_counter_permission" 
            :helper_permission="value_helper_permission" 
            :test_field_is_numeric="value_test_field_is_numeric" 
            :length="value_length"
            :computed_value="value_selected"
            :computed_value_permission="true"
            :is_input_textarea="value_is_input_text_area" />
        </div>
        <div style="text-align: center; margin-bottom: 30px;">
          <Button id="alarm-button" 
            @_emit_method_button="_postAlarm"  
            :button_icon="button_icon" 
            :button_name="button_name" 
            :button_key="button_key" 
            :button_icon_id="button_icon_id" />
        </div>
        <hr />
        <div>
          <Accordion class="widgets">
            <AccordionItem>
                <template slot="accordion-trigger">
                    <div>
                        <ol>
                            <li class="sector-text text-bold">Alarmas pendientes</li>
                        </ol>
                    </div>
                    <div>
                        <span class="material-icons accordion-icon">keyboard_arrow_down</span>
                    </div>
                </template>
                <template slot="accordion-content" class="accordion-desplegable">
                    <div v-for="(item, index) in pending_alarms" :key="index" class="pending-alarms-container">
                        <div style="display: flex">
                          <p class="registry-date">{{item.created}}</p>
                          <span class="material-icons-outlined" style="margin: 8px 6px 0 auto; font-size: 18px" @click="_deleteAlarm(item.id)">delete</span>
                        </div>
                        <p class="registry-text">Alarma planeada: <strong>{{item.ticker_name}}</strong> {{item.alert_field_string}} {{item.alert_mode_string}} {{item.alert_data}}</p>
                    </div>
                </template>
            </AccordionItem>
          </Accordion>
        </div>
    </div>
</template>



<script>
import { mapGetters } from "vuex";
import HeaderSidebarRight from './HeaderSidebarRight.vue';
import APICaller from "@/components/codeComponents/APICaller.js";
import SelectOutline from '@/components/helpers/SelectOutline.vue';
import InputTextOutline from "@/components/helpers/InputTextOutline.vue";
import Button from "@/components/helpers/Button.vue";
import Accordion from '@/components/helpers/accordion/Accordion';
import AccordionItem from '@/components/helpers/accordion/AccordionItem.vue';
import CheckBox from "@/components/helpers/CheckBox.vue";

export default {
    mixins:[APICaller],
    name: 'Alarmas',
    components: {
      HeaderSidebarRight,
      SelectOutline,
      InputTextOutline,
      Button,
      Accordion,
      AccordionItem,
      CheckBox,
    },
    props: {
    },
    data: () => ({
        id_header: 'alarms_header',
        title_header: 'Alarmas',

        key_select_field: "key_select_field",
        ref_select_field: "ref_select_field",
        component_class_select_field: "class-component-select-field",
        label_name_select_field: "Seleccionar campo",
        options_select_field: [],
        default_value_select_field: "",
        helper_select_permission_select_field: false,

        key_select_operation: "key_select_operation",
        ref_select_operation: "ref_select_operation",
        component_class_select_operation: "component_class_select_operation",
        label_name_select_operation: "",
        options_select_operation: [
          {name:"<", value: "Menor que"},
          {name: "=", value: "Igual a"},
          {name: ">", value: "Mayor que"},
        ],
        default_value_select_operation: ">",
        helper_select_permission_select_operation: false,

        value_input_label: "Configurar valor",
        value_input_helper: "",
        value_has_focus: false,
        value_icon_class: "value-icon-class",
        value_input_key_to_save_user_values: "value_input_key_to_save",
        value_input_class_character_counter: "value-character-counter",
        value_permission: true,
        value_icon_permission: false,
        value_character_counter_permission: false,
        value_helper_permission: true,
        value_test_field_is_numeric: true,
        value_length: 16,
        value_is_input_text_area: false,

        label_name_checkbox_cotizacion: "Cotización",
        key_checkbox_cotizacion: "key-checkbox-cotizacion",
        id_checkbox_cotizacion: "id-checkbox-cotizacion",
        value_checkbox_cotizacion: true,

        label_name_checkbox_entrada: "Entrada",
        key_checkbox_entrada: "key-checkbox-entrada",
        id_checkbox_entrada: "id-checkbox-entrada",
        value_checkbox_entrada: false,

        label_name_checkbox_stop: "Stop",
        key_checkbox_stop: "key-checkbox-stop",
        id_checkbox_stop: "id-checkbox-stop",
        value_checkbox_stop: false,

        label_name_checkbox_soporte: "Soporte",
        key_checkbox_soporte: "key-checkbox-soporte",
        id_checkbox_soporte: "id-checkbox-soporte",
        value_checkbox_soporte: false,

        label_name_checkbox_distancia_entrada: "Distancia de entrada",
        key_checkbox_distancia_entrada: "key-checkbox-distancia-entrada",
        id_checkbox_distancia_entrada: "id-checkbox-distancia-entrada",
        value_checkbox_distancia_entrada: false,

        button_icon: "button-icon",
        button_name: "Enviar",
        button_key: "key-alarm-button",
        button_icon_id: "button-icon-id",



        executed_alarms: [],
        pending_alarms: [],

        field_selected_text: "Cotización",
        field_selected_post: "valor_actual",
        operation_selected: ">",
        value_selected: "0",
        operation_text: "",
        uid: "",
    }),
  mounted() {
    this.initUserInfo();
    var waiting_for_uid = setInterval(() => {
      if(this.uid && this.uid != undefined && this.uid != ""){
        this._getAlarms()
        clearInterval(waiting_for_uid)
      }
    }, 200)

    var waiting_for_ticker = setInterval(()=>{
      if(this._g_SelectedTicker.resistance && this._g_SelectedTicker.resistance != undefined){
        if(!isNaN(parseFloat(this._g_SelectedTicker.resistance).toFixed(2))){
          this.value_selected = parseFloat(this._g_SelectedTicker.resistance).toFixed(2)
        }else{
          this.value_selected = "";
        }
        clearInterval(waiting_for_ticker)
      }
    }, 200)
  },
  created: function() {
    this._getValuesForFieldSelect()
  },
  watch: {
    _g_SelectedTicker(newVal, oldVal) {
      if(!isNaN(parseFloat(this._g_SelectedTicker.resistance).toFixed(2))){
        this.value_selected = parseFloat(this._g_SelectedTicker.resistance).toFixed(2)
      }else{
        this.value_selected = "";
      }
    }
  },
  computed: {
    ...mapGetters(['_g_SelectedTicker', "_g_User", "_g_UserFeatures"]),
  },
  methods: {

    _getValueFromCheckbox: function(key, field){
      document.getElementById("id-checkbox-cotizacion").checked = false;
      document.getElementById("id-checkbox-entrada").checked = false;
      document.getElementById("id-checkbox-soporte").checked = false;
      document.getElementById("id-checkbox-stop").checked = false;
      document.getElementById("id-checkbox-distancia-entrada").checked = false;

      let checkbox_id = key.replace("key-", "id-");
      document.getElementById(checkbox_id).checked = true;
      this.field_selected_post = field;
    },

    _deleteAlarm: function(id){
      let params = new URLSearchParams();
      params.append('uid', this.uid);
      params.append('alert_id', id);

      let success = response =>{
        this._getAlarms()
      }

      let url = "/api/v1/eurekers-alerts/delete"

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('241', 'Error borrando alarma.');

      this._postAPICall(url, params, successHandler, failureHandler);
    },

    _getValueFromOperationSelect: function(value){
      this.operation_selected = value[0]
    },
    _getValueFromInputValue: function(value){
      this.value_selected = value[0]
    },

    _getAlarms: function(){
      let params = new URLSearchParams();
      params.append('uid', this.uid);

      let success = response =>{
        this.pending_alarms = response.data.filter(alarm => alarm.status == 0)
      }

      let url = "/api/v1/eurekers-alerts/get-user-alerts"

      const successHandler = new APICaller.SuccessHandler(success);
      const failureHandler = new APICaller.FailureHandler('242', 'Error recuperando alarmas.');

      this._postAPICall(url, params, successHandler, failureHandler);
    },

    _postAlarm: function(){
      if(this.value_selected == ""){
        this.$vueOnToast.pop("error", "Por favor configure un valor para la alarma.")
      }else{
        let params = new URLSearchParams();
        params.append('uid', this.uid);
        params.append('ticker', this._g_SelectedTicker.ticker);
        params.append('alert_field', this.field_selected_post);
        params.append('alert_mode', this.operation_selected);
        params.append('alert_data', this.value_selected);
  
        let success = response =>{
            this.$vueOnToast.pop("success", "Alarma creada correctamente")
            this._getAlarms();
        }
  
        let url = "/api/v1/eurekers-alerts/create"
  
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler('243', 'Error al creat la nueva alarma.');

        if(this.pending_alarms.length < this._g_UserFeatures.permissions.simultaneous_active_alerts){
          this._postAPICall(url, params, successHandler, failureHandler);
        }else{
          this.$vueOnToast.pop("error", "Ha alcanzado el número máximo de alarmas para su plan.");
        }

      }
    },

    _getValuesForFieldSelect: function(){
      this.options_select_field= [
        {name: "valor_actual", value: "Cotización"},
        {name: "entrada", value: "Entrada"},
        {name:"entry_distance", value:"Distancia de entrada"},
        {name: "soport", value:"Soporte"},
        {name: "out_price", value: "Stop"},
      ]
      //TODO: llamada api que recoje los campos que se pueden seleccionar para la alarma
    },



    initUserInfo: function(){
      this.uid = this._g_User.uid;
    },
  },
}
</script>


<style lang="scss" scoped>
  @import "@/styles/basics/globals.scss";

  .alarm-container {
    text-align: center;
    margin:20px;
  }

  .info-ticker-box {
     width: 100%;
     display: flex;
     justify-content: center;
  }
  .text-info-ticker {
    text-align: center;
    background-color: #F3F4F7;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin-bottom: 26px;
    width: 130px;
    padding: 7px 20px;
  }

  .text-bold {
    font-weight: bold;
  }

  .field-container{
    border: 1px solid black;
    height: 40px;
    width: 70px;
    font-size: 12px;
    margin: 0 5px 20px 5px;
    border-radius: 30px;
    display: flex;
    align-items: center;
  }

  .trash-icon-container{
    display: flex;
    align-items: center;
  }

  .checkbox-container{
    display: flex; 
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 20px;
    margin-top: -20px;
  }

  .every-checkbox-container{
    width: 50%;
  }

  .registry-date{
    width: 77px;
    height: 24px;

    /* Subtitle 2 */

    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */

    letter-spacing: 0.1px;

    /* Tema Claro/02. Primary/900 */

    color: #000010;

    padding: 10px 0 0 15px;
  }

  .registry-text{
    width: 341px;

    /* Caption */

    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    /* or 133% */

    letter-spacing: 0.4px;

    /* Tema Claro/02. Primary/900 */

    color: #000010;

    padding: 5px 0 15px 15px;
  }

  .pending-alarms-container{
    margin-left: 5px;
    border: 1px solid lightgrey;
    border-left: 5px solid #42a0c9;
    display: block;
    margin-bottom: 10px;
    border-radius: 5px;
  }

  #alarms label, #alarms p, #alarms span {
    color: var(--custom-color-right-menu-font);
  }

  .text-info-ticker {
    background-color: var(--custom-color-right-menu-highlight);
  }
</style>